import {
  UserSubscription,
  UserSubscriptionCategory,
  UserSubscriptionIds,
  UserSubscriptionType
} from "./user-subscription";
import {UserSubscriptionPlanMapper} from "./user-subscription-plan-mapper";
import {UserSubscriptionStatus} from "./user-subscription-status";
import {TypeUtils} from "../shared/utils/type-utils";
import {Utils} from "../shared/utils/utils";
import {Config} from "../config/config";

export class UserSubscriptionMapper {

  public static map(data: any, planDescriptionMap?: any): UserSubscription {
    const userSubscription: UserSubscription = new UserSubscription();
    const _plan = data && data.plan?.length ? data.plan[0] : data?.plan;
    userSubscription.status = data && (data.subscription_category === 'appsumo' || data.subscription_category === UserSubscriptionType.TENWEBX_LTD || data.subscription_category === UserSubscriptionType.TENWEBX_RECURRING) ? (userSubscription.expireDate && userSubscription.isExpired ? UserSubscriptionStatus.expired : (userSubscription.cancelDate ? UserSubscriptionStatus.canceled : data.status)) : (data.status === UserSubscriptionStatus.canceled && userSubscription.isExpired ? UserSubscriptionStatus.expired : data.status);
    userSubscription.expireDate =   (data.subscription_category === 'appsumo' || data.subscription_category === UserSubscriptionType.TENWEBX_LTD || data.subscription_category === UserSubscriptionType.TENWEBX_RECURRING ? (data.app_sumo_expire_date ? Utils.getDate(data.app_sumo_expire_date) : data.app_sumo_expire_date) : (data.expire_date ? Utils.getDate(data.expire_date) : data.expire_date));
    userSubscription.appsumoIsExpired = data && (data.subscription_category && (data.subscription_category === 'appsumo' || data.subscription_category === UserSubscriptionType.TENWEBX_LTD || data.subscription_category === UserSubscriptionType.TENWEBX_RECURRING) && data.payment_fail && data.payment_fail >= 3);

    userSubscription.id = data && data.agency_product_id;
    userSubscription.corePlanId = data && (data.subscription_id || data.id);
    userSubscription.agencyFeatures = data && data.agency_features;
    userSubscription.type = (data && [UserSubscriptionType.TENWEBX_LTD, UserSubscriptionType.TENWEBX_RECURRING, UserSubscriptionType.APPSUMO].includes(data.subscription_category) ? UserSubscriptionType.PLATFORM : data.subscription_category) || UserSubscriptionType.PREMIUM;
    userSubscription.newPlan = (_plan && _plan.json_desc_short && _plan.json_desc_short.newPlan);
    userSubscription.variant = (_plan && _plan.json_desc_short && _plan.json_desc_short.variant) || 'a';
    userSubscription.oldPersonalPlatform = (_plan && _plan.json_desc_short && _plan.json_desc_short.oldPersonal) || false;
    userSubscription.dedicatedHosting = (_plan && _plan.json_desc_short && _plan.json_desc_short.dedicatedHosting) || false;
    userSubscription.isDedicatedVM = (data && (data.subscription_category === UserSubscriptionCategory.DedicatedVM)) || false;
    userSubscription.hasEcommerceWebsite = ( _plan && _plan.json_desc_short && _plan.json_desc_short.website === 'ecommerce') || false;
    userSubscription.hasProfessionalWebsite = (_plan && _plan.json_desc_short && _plan.json_desc_short.website === 'professional') || false;
    userSubscription.category = _plan && _plan.json_desc_short && _plan.json_desc_short.hostingPlanCategory ? ([UserSubscriptionType.TENWEBX_LTD, UserSubscriptionType.TENWEBX_RECURRING, UserSubscriptionType.APPSUMO].includes(data.subscription_category) ? 'personal' : _plan.json_desc_short.hostingPlanCategory) : UserSubscriptionCategory.NONE;
    userSubscription.dedicatedInfo = _plan && _plan.json_desc_short && _plan.json_desc_short.cpuCore ?
      {
        cpuCore: _plan.json_desc_short.cpuCore,
        phpWorkers: _plan.json_desc_short.phpWorkers,
        ram: _plan.json_desc_short.ram,
      } : null;
    switch (userSubscription.category) {
      case UserSubscriptionCategory.STARTER:
        userSubscription.title = Utils.uppercaseFirst(data.title || data.plan_title || 'starter');
        break;

      case UserSubscriptionCategory.PERSONAL:
        userSubscription.title = Utils.uppercaseFirst(data.title || data.plan_title || 'personal');
        break;

      case UserSubscriptionCategory.PREMIUM:
        userSubscription.title = Utils.uppercaseFirst(data.title || data.plan_title || 'premium');
        break;

      case UserSubscriptionCategory.ENTERPRISE:
        userSubscription.title = Utils.uppercaseFirst(data.title || data.plan_title || 'enterprise');
        break;

      case UserSubscriptionCategory.ENTERPRISE_ULTIMATE:
        userSubscription.title = Utils.uppercaseFirst(data.title || data.plan_title || 'enterprise-ultimate');
        break;

      case UserSubscriptionCategory.PROFESSIONAl:
        userSubscription.title = Utils.uppercaseFirst(data.title || data.plan_title || 'professional');
        break;

      default:
        switch (userSubscription.type) {
          case UserSubscriptionType.FREE:
            userSubscription.title = 'Starter';
            break;

          case UserSubscriptionType.ONE_PRODUCT:
            userSubscription.title = 'Single product';
            break;

          case UserSubscriptionType.PREMIUM:
            userSubscription.title = 'Premium Bundle';
            break;
        }
        break;
    }
    userSubscription.professionalPlan = userSubscription.category &&  userSubscription.category === UserSubscriptionCategory.PROFESSIONAL;
    userSubscription.hasEcommerceWebsite = (_plan && _plan.json_desc_short && _plan.json_desc_short.website === 'ecommerce') || false;
    userSubscription.hasProfessionalWebsite = (  _plan && _plan.json_desc_short && _plan.json_desc_short.website === 'professional') || false;
    userSubscription.productSlug = _plan && _plan.json_desc_long.premiumPluginKey; // TODO:
    userSubscription.periodNumber =   _plan && _plan.period_number; // TODO:
    userSubscription.pluginTitle =   data && data.title ? data.title.replace(/[^a-z-A-Z ]/g, "").replace(/-+/, "").replace(/\s+$/, '') : '';
    userSubscription.agreementDate =   data.agreement_date ? Utils.getDate(data.agreement_date) : null;
    userSubscription.nextBillingDate =   data.next_payment_date ? Utils.getDate(data.next_payment_date) : null;
    userSubscription.cancelDate = data?.cancel_date ? Utils.getDate(data.cancel_date) : null;
    userSubscription.discountPercent = _plan && _plan.discount_percent;
    userSubscription.monthlyPrice = _plan && _plan.monthly_price;
    userSubscription.discountAmount = _plan && _plan.discount_amount;
    userSubscription.amountWithoutDiscount = _plan && _plan.unit_amount_without_discount;

    let nextPausedDateTimestamp = null;
    if (userSubscription.cancelDate && data.cancel_date) {
      // Convert the cancelDate to a Date object
      let cancelDateObject = new Date(userSubscription.cancelDate);

      // Add 6 months to the date
      cancelDateObject.setMonth(cancelDateObject.getMonth() + 6);

      // Format the updated date back to a string (optional)
      let pausedExpirationDate = cancelDateObject && cancelDateObject.toISOString().split('T')[0];

      // Update userSubscription.pausedExpirationDate conditionally
      userSubscription.pausedExpirationDate =
        data.paused && pausedExpirationDate
          ? Utils.getDate(pausedExpirationDate)
          : null;
      nextPausedDateTimestamp = userSubscription.pausedExpirationDate && new Date(userSubscription.pausedExpirationDate.getFullYear() + '-' + ("0" + (userSubscription.pausedExpirationDate.getMonth() + 1)).slice(-2) + '-' + ("0" + userSubscription.pausedExpirationDate.getDate()).slice(-2)).getTime();
    }

    const todayTimestamp = new Date(new Date().getFullYear() + '-' + ("0" + (new Date().getMonth() + 1)).slice(-2) + '-' + ("0" + new Date().getDate()).slice(-2)).getTime();
    const nextBillingDateTimestamp = userSubscription.nextBillingDate && new Date(userSubscription.nextBillingDate.getFullYear() + '-' + ("0" + (userSubscription.nextBillingDate.getMonth() + 1)).slice(-2) + '-' + ("0" + userSubscription.nextBillingDate.getDate()).slice(-2)).getTime();
    const expireDateTimestamp = userSubscription.expireDate && new Date(userSubscription.expireDate.getFullYear() + '-' + ("0" + (userSubscription.expireDate.getMonth() + 1)).slice(-2) + '-' + ("0" + userSubscription.expireDate.getDate()).slice(-2)).getTime();

    userSubscription.isExpired = (userSubscription.paused && userSubscription.pausedExpirationDate && !TypeUtils.isNull(nextPausedDateTimestamp) && nextPausedDateTimestamp < todayTimestamp ) || (userSubscription.nextBillingDate && nextBillingDateTimestamp < todayTimestamp) || (userSubscription.expireDate && expireDateTimestamp < todayTimestamp) || (  data.status === UserSubscriptionStatus.failed);
    /*TODO fix this with core*/
    userSubscription.cancelDate = data && data.cancel_date ? Utils.getDate(data.cancel_date) : null;
    userSubscription.clientId = data?.clients_id;
    userSubscription.paymentType = data?.payment_type;
    userSubscription.paypalEmail = data?.paypal_email;
    userSubscription.couponCode = data?.coupon_code;
    userSubscription.lifetimeCoupon = Utils.isTruthy(data.is_coupon_lifetime);
    userSubscription.couponApplyDaysForRenew = data.coupon_apply_days_for_renew ? parseInt(data.coupon_apply_days_for_renew, 10) : null;
    const failsCount: any = TypeUtils.isString(data.payment_fail) ? parseInt(data.payment_fail, 10) : data.payment_fail;
    userSubscription.paymentFailed = TypeUtils.isNumber(failsCount) && !isNaN(failsCount) && failsCount > 0;
    userSubscription.paymentFailedCount = TypeUtils.isNumber(failsCount) && !isNaN(failsCount) && failsCount;
    userSubscription.recharge = userSubscription.paymentFailed && data.status === UserSubscriptionStatus.active && userSubscription.paymentFailedCount < 4 && userSubscription.nextBillingDate && userSubscription.nextBillingDate.getTime() < new Date(new Date().getTime() + 7 * 24 * 60 * 60 * 1000).getTime();
    const renewWithLifeTimeCoupon = data && userSubscription && userSubscription.expireDate && userSubscription.couponApplyDaysForRenew && userSubscription.couponCode && userSubscription.lifetimeCoupon && +Utils.getDaysDiffFromToday(userSubscription.expireDate, false) < userSubscription.couponApplyDaysForRenew;
    userSubscription.plans = data && data.plan && data.plan.length ?
      data.plan.reduce((acc: any, plan: any) => {
        const zoneName = plan && plan.json_desc_short && plan.json_desc_short.vm_zone_name;
        if (zoneName) {
          acc[zoneName] = UserSubscriptionPlanMapper.map(
            userSubscription.type,
            plan,
            data.plan_title,
            planDescriptionMap,
            renewWithLifeTimeCoupon,
            userSubscription.isExpired,
            !!userSubscription.couponCode,
            !!userSubscription.newPlan
          );
        }
        return acc;
      }, {})
      : null;

    userSubscription.plan = planDescriptionMap && _plan ? UserSubscriptionPlanMapper.map(data.subscription_category, _plan, data.plan_title, planDescriptionMap, renewWithLifeTimeCoupon, userSubscription.isExpired, !!userSubscription.couponCode, !!userSubscription.newPlan) : null;
    userSubscription.isDefault = Utils.isTruthy(data.default);
    userSubscription.realStatus = data.status;
    userSubscription.subscriptionTitle = data.title || '';
    userSubscription.subscriptionTitleName = data.subscription_title || '';
    userSubscription.subscriptionOriginalTitle = data.subscription_original_title || '';
    userSubscription.presentableTitle = data.presentable_title || data.subscription_title || '';
    userSubscription.subscriptionId = data.subscription_id;
    userSubscription.product_id = data.product_id;
    userSubscription.additionalWebsiteCount = !userSubscription.newPlan ? data.additional_domains_count : 0;
    userSubscription.trialClient = data.type === 'starter';
    userSubscription.trialOptimizerClient = data.subscription_id === UserSubscriptionIds.TRIAL_OPTIMIZER;
    userSubscription.boosterProClient = data.subscription_category === UserSubscriptionType.BOOSTER && (_plan && _plan.json_desc_short && _plan.json_desc_short.booster && _plan.json_desc_short.booster === 'pro');
    userSubscription.platformPaidClient = data && [UserSubscriptionCategory.PLATFORM, UserSubscriptionCategory.DedicatedVM].includes(userSubscription.type as UserSubscriptionCategory);
    userSubscription.trialBoosterClient = data && data.subscription_id === UserSubscriptionIds.TRIAL_BOOSTER;
    userSubscription.boosterCategory = data.subscription_category === UserSubscriptionType.BOOSTER && _plan && _plan.json_desc_short && _plan.json_desc_short.boosterCategory;
    userSubscription.aiPrice = data.subscription_category === UserSubscriptionType.BOOSTER && _plan && _plan.json_desc_short && _plan.json_desc_short.aiPrice && parseInt(_plan.json_desc_short.aiPrice, 10);
    userSubscription.boosterPrice = data.subscription_category === UserSubscriptionType.BOOSTER && _plan && _plan.json_desc_short && _plan.json_desc_short.boosterPrice && parseInt(_plan.json_desc_short.boosterPrice, 10);
    userSubscription.paidClient = userSubscription && (userSubscription.boosterProClient || userSubscription.platformPaidClient);

    userSubscription.freeBaseClient = data.subscription_id === UserSubscriptionIds.FREE_BASE;
    userSubscription.boosterBetaClient = data.subscription_id === UserSubscriptionIds.BOOSTER_BETA;
    userSubscription.oneProductClient = data.type === UserSubscriptionType.ONE_PRODUCT
      || data.subscription_category === UserSubscriptionType.ONE_PRODUCT;
    userSubscription.bundleClient = data.type === UserSubscriptionType.PREMIUM
      || data.subscription_category === UserSubscriptionType.PREMIUM;
    userSubscription.oneProductOrBundle = userSubscription.oneProductClient || userSubscription.bundleClient;
    const date: Date = new Date();
    if (userSubscription.plan && userSubscription.plan.trialPeriodNumber) {
      switch (userSubscription.plan.trialPeriodType) {
        case 'y':
          date.setFullYear(date.getFullYear() + userSubscription.plan.trialPeriodNumber);
          break;
        case 'm':
          date.setMonth(date.getMonth() + userSubscription.plan.trialPeriodNumber);
          break;
        case 'd':
          date.setDate(date.getDate() + userSubscription.plan.trialPeriodNumber);
          break;
      }
    }
    userSubscription.firstPaymentDate = userSubscription.plan && userSubscription.plan.trialPeriodNumber ? date : null;
    userSubscription.canReactivate = Utils.isTruthy(data.can_reactivate);
    userSubscription.hostingTrialExpireDate = data.hosting_trial_expire_date;
    userSubscription.hasHostingTrial = data.has_hosting_trial;
    userSubscription.hostingTrialExpired = data.hosting_trial_expired;
    userSubscription.domainsPermission = {
      canConnectWebsite: data.domains_permission && data.domains_permission.can_connect_website,
      canConnectSpeedWebsite: data.domains_permission && data.domains_permission.can_connect_speed_website,
      canConnectAIWebsite: data.domains_permission && data.domains_permission.can_connect_ai_website,
      canCreateWebsite: data.domains_permission && data.domains_permission.can_create_website,
    };
    userSubscription.canEnableCdn = data.cdn_permissions && data.cdn_permissions.can_add_cdn;
    userSubscription.freeDaysBeforePayment = +data.free_days_before_payment;
    userSubscription.freeDaysAfterPayment = +data.free_days_after_payment;
    userSubscription.paused = data.paused;
    userSubscription.isGeo = data && (data.subscription_category === UserSubscriptionType.PLATFORM || data.subscription_category === UserSubscriptionType.FREE) && _plan && _plan.json_desc_short && _plan.json_desc_short.geo;
    userSubscription.isBusiness =   _plan && _plan.json_desc_short && _plan.json_desc_short.tabCategory && _plan.json_desc_short.tabCategory === 'business' || false;
   // userSubscription.isEcommerce = _plan && _plan.json_desc_short && _plan.json_desc_short.tabCategory && _plan.json_desc_short.tabCategory === 'ecommerce' || false;
    userSubscription.isAgency =   _plan && _plan.json_desc_short && _plan.json_desc_short.tabCategory && _plan.json_desc_short.tabCategory === 'agency' || false;
    userSubscription.tabCategory = (  _plan && _plan.json_desc_short && _plan.json_desc_short.tabCategory) || '';
    userSubscription.coupleId = (  _plan && _plan.json_desc_short && _plan.json_desc_short.coupleSubscId) || '';
    userSubscription.defaultPrice = Number((  _plan && _plan.json_desc_short && _plan.json_desc_short.defaultPrice)) || 0;
    userSubscription.defaultPrice1 = Number((  _plan && _plan.json_desc_short && _plan.json_desc_short.defaultPrice1)) || 0;
    userSubscription.hasActiveDomainAgreement = data.has_active_domain_agreement || false;
    userSubscription.hasDomainAgreement = data.has_domain_agreement || false;
    userSubscription.apiResellerFree = (data.subscription_id || data.id) === UserSubscriptionIds.API_RESELLER;
    userSubscription.apiResellerPro = _plan && _plan.json_desc_short && _plan.json_desc_short.tabCategory && _plan.json_desc_short.apiReseller === 'pro' || false;
    userSubscription.isApiResellerPlan = _plan && _plan.json_desc_short && _plan.json_desc_short.apiReseller && !!_plan.json_desc_short.apiReseller || false;
    userSubscription.agencyFeatures = data && data.agency_features || null;
    const woocommerceFeature = data && data.agency_features && Array.isArray(data.agency_features)
        ? data.agency_features.find(item => item && item.slug === "allow_woocommerce_service")
        : (data && data.agency_features && typeof data.agency_features === 'object'
            ? Object.values(data.agency_features).find((item: any) => item && item.slug === "allow_woocommerce_service")
            : null);
    userSubscription.isEcommerce = woocommerceFeature && (woocommerceFeature.value === "1" || woocommerceFeature.value === 1 || woocommerceFeature.value === 'true');
    const builderType = data && data.agency_features && Array.isArray(data.agency_features)
        ? data.agency_features.find(item => item && item.slug === "builder_type")
        : (data && data.agency_features && typeof data.agency_features === 'object'
            ? Object.values(data.agency_features).find((item: any) => item && item.slug === "builder_type")
            : null);
    userSubscription.builderType = builderType?.value ?? null;
    userSubscription.agencyCustomerData = data && data.agency_customer_data ? {
      customer_id: data.agency_customer_data.customer_id,
      provider_subscription_id: data.agency_customer_data.provider_subscription_id
    } : null;
    userSubscription.stripeSbcrstatus = data && data.provider_subscription_status;
    const wvcStats = data.wvc_usage_statistics || null;
    userSubscription.wvcUsage = data.wvc_usage_statistics || null;
    userSubscription.editUsed = wvcStats?.wvc_edit_used || 0;
    userSubscription.editTotal = wvcStats?.data?.edit?.count || 0;
    userSubscription.generationsUsed = wvcStats?.wvc_website_create_used || 0;
    userSubscription.generationsTotal = wvcStats?.data?.website_create?.count || 0;
    userSubscription.vibeWebsitesUsed = wvcStats?.websites?.created || 0;
    userSubscription.vibeWebsitesTotal = wvcStats?.websites?.count || 0;
    userSubscription.availableBuilder =  UserSubscriptionMapper.setAvailableBuilder(userSubscription.builderType, data);
    userSubscription.multipleBuilder = builderType?.value === 'both' && !!data?.plan?.services?.ai_builder && !!data?.plan?.services?.wvc;
    userSubscription.is_non_billable = data?.is_non_billable;
    return userSubscription;
  }

  public static setAvailableBuilder(
    builderType: string | number,
    subscription: any
  ): 'wvc' | 'section_based' {
    const hasAiBuilder = !!subscription?.plan?.services?.ai_builder;
    const hasWvc = !!subscription?.plan?.services?.wvc;

    // Handle 'both' builderType
    if (builderType === 'both') {
      if (hasAiBuilder && hasWvc) {
        return 'wvc';  // Return 'wvc' when both services available
      } else if (hasAiBuilder && !hasWvc) {
        return 'section_based';
      } else if (!hasAiBuilder && hasWvc) {
        return 'wvc';
      }
    }

    // For 'wvc' or 'section_based', always honor the builderType
    if (builderType === 'wvc' || builderType === 'section_based') {
      return builderType;
    }

    // Default fallback (shouldn't happen based on user clarification)
    return 'section_based';
  }

}
